'use strict';

const _ = require('lodash');
const workerUtils = require('./workerUtils');
const {bi, ACTION_NAMES} = require('../utils/loggingUtils');
const scriptsValidator = require('./scriptsValidator');
const scriptRunner = require('./scriptRunner');
const events = require('../events');
const experiments = require('../stores/selectors/experiments');
const { USE_WIX_CODE_APP_EXPERIMENT } = require('../constants/constants');
const { WIX_CODE_VIEWER_APP} = require('../constants/store');

function getEmptyModule() {
  return {};
}

function loadScripts(scripts, userCodeStore, workerId) {
  const appId = 'wixCode';
  const devConsole = console; // eslint-disable-line no-console

  const filteredScripts = scripts.filter(script => !userCodeStore.get(script.url));

  if (_.isEmpty(filteredScripts)) {
    return;
  }

  filteredScripts.forEach(script => {
    try {
      const moduleFunc = workerUtils.importScriptsAsAmdModule(self, appId, script.url, script.displayName);
      userCodeStore.set(script.url, scriptRunner.runScript.bind(this, devConsole, appId, script, moduleFunc));
    } catch (e) {
      devConsole.error('There was an error in your script');
      devConsole.error(e);
      userCodeStore.set(script.url, getEmptyModule);
    }
  });

  bi.report(events.USER_CODE_LOADED, {
    name: ACTION_NAMES.USER_CODE_LOADED,
    worker_id: workerId
  });
}

function handleLoadUserCode({wixCode, workerId} = {}, {userCodeStore, store}) {
  scriptsValidator.validate(wixCode, ['id', 'url', 'scriptName', 'displayName']);

  const useWixCodeApp = experiments.isExperimentOpen(store, USE_WIX_CODE_APP_EXPERIMENT);
  const routerData = _.get(wixCode, ['0', 'routerData']);

  if (useWixCodeApp) {
    if (!_.isEmpty(wixCode)) {
      const wixCodeViewerApp = store.getValue(WIX_CODE_VIEWER_APP);
      wixCodeViewerApp.fetchUserCode(wixCode, workerUtils.importScriptsAsAmdModule.bind(self, self, 'wixCode'), {routerData});

      bi.report(events.USER_CODE_LOADED, {
        name: ACTION_NAMES.USER_CODE_LOADED,
        worker_id: workerId
      });
    }
  } else {
    if (routerData) {
      self.routerData = routerData;
    }
    loadScripts(wixCode, userCodeStore, workerId);
  }
}

module.exports = {
  handleLoadUserCode
};
